const Loader = () => {
  return (
    <section className="flex items-center justify-center min-h-screen px-4 py-12 bg-[#f5f5f5] sm:px-6 lg:px-8">
      <span className="loader" />
    </section>
  );
};

export default Loader;
